import React from 'react';

export const MerchantListSkeleton: React.FC = () => {
  return (
    <div className="space-y-2">
      {[...Array(10)].map((_, i) => (
        <div 
          key={i} 
          className="flex items-center space-x-3 p-3 rounded-lg bg-[var(--bg-tertiary)] animate-pulse"
        >
          {/* Avatar skeleton */}
          <div className="w-8 h-8 rounded-full bg-gray-300 flex-shrink-0"></div>
          
          {/* Text skeleton */}
          <div className="flex-1 min-w-0 space-y-2">
            <div className="h-4 bg-gray-300 rounded w-3/4"></div>
            <div className="h-3 bg-gray-300 rounded w-1/2"></div>
          </div>
        </div>
      ))}
    </div>
  );
};
